import { defaultDictionaryValueMissing } from '../repository';

export type ContactKey = 'Email' | 'Phone' | 'Address' | 'OpeningHours' | 'ChooseYourCity';

export const getDefaultContactValue = (key: ContactKey): string => {
	switch (key) {
		case 'Email':
			return 'Email';
		case 'Phone':
			return 'Telefon';
		case 'Address':
			return 'Adresse';
		case 'OpeningHours':
			return 'Åbningstider';
		case 'ChooseYourCity':
			return 'Vælg din by/bygd';
		default:
			return `${defaultDictionaryValueMissing}:${key}`;
	}
};
